var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroup = function SvgGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#747474",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M26.4 4H5.6C4.164 4 3 5.535 3 7.429V24.57C3 26.465 4.164 28 5.6 28h20.8c1.436 0 2.6-1.535 2.6-3.429V7.43C29 5.535 27.836 4 26.4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#747474",
    fillRule: "evenodd",
    d: "M7 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4-2a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2zM7 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4-2a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2zM7 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4-2a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })));
};
export { SvgGroup as ReactComponent };